var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleLeftArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 9,
    viewBox: "0 0 13 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.90168 5.29412L12.3848 8.94646C12.4561 8.99405 12.5315 9.00991 12.6108 8.99405C12.69 8.97819 12.7535 8.93457 12.8011 8.86319C12.8328 8.8156 12.8486 8.76008 12.8486 8.69663V0.297426C12.8486 0.210182 12.8189 0.138801 12.7594 0.0832815C12.7 0.0277634 12.6306 3.8147e-06 12.5513 3.8147e-06C12.4879 3.8147e-06 12.4323 0.0158663 12.3848 0.0475912L6.90168 3.69994V0.297426C6.90168 0.210182 6.87194 0.138801 6.81247 0.0832815C6.753 0.0277634 6.68362 3.8147e-06 6.60433 3.8147e-06C6.54089 3.8147e-06 6.48539 0.0158663 6.43781 0.0475912L0.134039 4.24719C0.0706043 4.29478 0.0289755 4.35823 0.00915241 4.43754C-0.0106707 4.51686 0.0032053 4.5922 0.0507812 4.66358C0.0745687 4.69531 0.102322 4.72307 0.134039 4.74686L6.43781 8.94646C6.50918 8.99405 6.5845 9.00991 6.6638 8.99405C6.74309 8.97819 6.80652 8.93457 6.8541 8.86319C6.88582 8.8156 6.90168 8.76008 6.90168 8.69663V5.29412ZM7.85319 4.49703L11.6592 1.96299V7.03106L7.85319 4.49703ZM5.71228 1.96299V7.03106L1.90623 4.49703L5.71228 1.96299Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleLeftArrowIcon);
export default __webpack_public_path__ + "static/media/DoubleLeftArrowIcon.b0e0bee8cb4faa4b2805a410778bbc7e.svg";
export { ForwardRef as ReactComponent };